import React, { useEffect, useState } from 'react';
import ReusableTable from '../../../components/common/table';
import { ReactComponent as ViewSvg } from "../../../assets/images/action/view.svg";
import { ReactComponent as DeleteSvg } from "../../../assets/images/action/delete.svg";
import { ReactComponent as EditSvg } from "../../../assets/images/action/edit.svg";
import { ReactComponent as DisableSvg } from "../../../assets/images/action/Shield Cross.svg";
import { useLocation, useNavigate } from 'react-router';
import { ReactComponent as UserSvg } from "../../../assets/images/description/User.svg";
import { ReactComponent as EmailSvg } from "../../../assets/images/description/Message.svg";
import { Descriptions } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { listPodcastTenantFun } from '../../../redux/reducer/TenantSlice';
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { ArrowLeftOutlined } from "@ant-design/icons";

const ViewTenantUser = () => {
  const [modalConfig, setModalConfig] = useState({ open: false, actionType: "" });
  const dispatch = useDispatch();
  const [userData, setUserData] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const [currentPage, setCurrentPage] = useState(1);

  const getInitialParams = () => {
    const page = parseInt(searchParams.get("page")) || 1;
    const size = parseInt(searchParams.get("size")) || 10;
    const search_key = searchParams.get("search_key") || "all";
    const search_value = searchParams.get("search_value") || "";
    const status = searchParams.get("status");
    const position = searchParams.get("position");

    return {
      page,
      size,
      search_key,
      search_value,
      status: status !== null ? Number(status) : undefined,
      position: position !== null ? Number(position) : undefined,
    };
  };

  const [tableParams, setTableParams] = useState(getInitialParams());

  useEffect(() => {
    const params = {
      page: tableParams.page,
      size: tableParams.size,
      search_key: tableParams.search_key,
      search_value: tableParams.search_value,
    };
    if (tableParams.status !== undefined) params.status = tableParams.status;
    if (tableParams.position !== undefined) params.position = tableParams.position;

    setSearchParams(params);
  }, [tableParams, setSearchParams]);

  // 🚀 Persist user record on refresh
  useEffect(() => {
    const currentRecord = location?.state?.record;

    if (currentRecord?.id) {
      localStorage.setItem("tenantUserRecord", JSON.stringify(currentRecord));
      setUserData(currentRecord);
      dispatch(listPodcastTenantFun({ user_id: currentRecord.id, ...tableParams }));
    } else {
      const storedRecord = localStorage.getItem("tenantUserRecord");
      if (storedRecord) {
        const parsedRecord = JSON.parse(storedRecord);
        setUserData(parsedRecord);
        dispatch(listPodcastTenantFun({ user_id: parsedRecord.id,  ...tableParams }));
      } else {
        navigate("/tenant-mgmnt/view-tenant");
      }
    }
  }, [dispatch, location?.state?.record?.id, tableParams]);

  const { listPodcastTenant, listPodcastTenantLoading, listPodcastTenantCount } = useSelector(
    (prev) => prev?.tenant
  );

  const user_details = [
    {
      key: "1",
      label: (
        <>
          <UserSvg /> User’s Name
        </>
      ),
      children: userData?.name_en ?? "user",
    },
    {
      key: "2",
      label: (
        <>
          <EmailSvg /> Email
        </>
      ),
      children: userData?.email ?? "user",
    },
  ];

  const columns = [
    {
      title: "SR. NO.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: (text, record, index) => (tableParams.page - 1) * tableParams.size + index + 1,
      width: "100px",
    },
    {
      title: "Podcast Title",
      dataIndex: "title_en",
      key: "category_name",
      type: "search",
      render: (title_en) =>
        title_en && title_en.length > 30 ? `${title_en.slice(0, 30)}...` : title_en,
    },
    {
      title: "Rating",
      dataIndex: "rating",
      key: "about_author",
      type: "search",
    },
    {
      title: "Last Played Date",
      dataIndex: "updated_at",
      key: "date_added",
      type: "date",
      render: (date) => dayjs(date).format("MM-DD-YYYY"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      type: "select",
      options: [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 0 },
      ],
      render: (status) => (status === 1 ? "Completed" : "Inprogress"),
    },
  ];

  const paginationConfig = {
    pageSizeOptions: ["10", "20", "50"],
    showSizeChanger: true,
    showQuickJumper: true,
    total: listPodcastTenantCount || 1,
    current: tableParams.page,
    pageSize: tableParams.size,
    onChange: (page, pageSize) => {
      setCurrentPage(page);
      setTableParams((prev) => ({ ...prev, page, size: pageSize }));
    },
  };

  return (
    <div>
      <div className="tabHeading">
        <ArrowLeftOutlined
          onClick={() => navigate("/tenant-mgmnt/view-tenant")}
          style={{ fontSize: "18px", marginRight: "10px" }}
        />
        User Details
      </div>

      <div className="customDescription ant-card-body-new">
        <Descriptions
          className="custom_descriptions"
          layout="vertical"
          items={user_details}
          size="small"
          column={{ xs: 1, sm: 2, md: 3 }}
        />
      </div>

      <div className="tabHeading">User Activity</div>

      <ReusableTable
        columns={columns}
        dataSource={listPodcastTenant}
        loading={listPodcastTenantLoading}
        paginationConfig={paginationConfig}
      />
    </div>
  );
};

export default ViewTenantUser;
